import React from "react"

import RichMediaMaster from "./RichMediaMaster"

type Props = {
  backgroundVideo?: string
  backgroundImage: string
  backgroundImageAlt: string
  icon?: string
  iconAlt?: string
  mobileGridOrder?: number
  isSliderChild?: boolean
  autoplay?: boolean
}

const Highlight = (props: Props) => {
  return <RichMediaMaster type="imageWithIcon" {...props} />
}

export default Highlight
